export default __webpack_public_path__ + "static/media/bl12.da559375.png";